import { utils } from "vincent-utils";
import { typeConsts } from "../../cadendar-consts.js";
import { HMObject } from "../../types/HMObject.js";
import { DateTime } from "luxon";
const { addToHmObj } = utils;
const getFin = (rdv) => {
    return addToHmObj({ heure: rdv.hour, minute: rdv.minute }, rdv.duration);
};
const rdvHasFlag = (rdv, flag) => {
    return Array.isArray(rdv.patient_flags) && rdv.patient_flags.includes(flag);
};
const isCanceled = (rdv) => {
    return rdv.type === typeConsts.ANN || rdv.type === typeConsts.ANNTARD;
};
const isClosed = (rdv) => {
    return rdv.type === typeConsts.FERME;
};
const isReservedForDocto = (rdv) => {
    return rdv.type === typeConsts.RESERVEDFORDOCTO;
};
const displayForBot = (rdv) => {
    console.log("rdv to displayForBot", rdv);
    const hmStart = new HMObject(rdv);
    const hmEnd = hmStart.addWithClone(rdv.duration);
    const jour = DateTime.fromJSDate(rdv.date).setLocale("fr").toFormat("cccc");
    return `le ${jour} ${rdv.date.toLocaleDateString()} de ${hmStart.toString()} à ${hmEnd.toString()}`;
};
const isRegularApt = (rdv) => {
    return (rdv.type !== typeConsts.ANN &&
        rdv.type !== typeConsts.ANNTARD &&
        rdv.type !== typeConsts.FERME &&
        rdv.type !== typeConsts.RESERVEDFORDOCTO);
};
const RdvMethods = {
    getFin,
    rdvHasFlag,
    isCanceled,
    isClosed,
    isReservedForDocto,
    displayForBot,
    isRegularApt,
};
export { RdvMethods, displayForBot };
//# sourceMappingURL=rdvMethods.js.map